/*
 * Copyright (c) 2024 Paul Ostrowski. All rights reserved.
 *
 * This software is the proprietary information of Paul Ostrowski.
 * Unauthorized copying, modification, or distribution of this code, via any medium, is strictly prohibited.
 * This code is proprietary and confidential.
 *
 * For licensing inquiries, contact Paul Ostrowski at postrowski@gmail.com.
*/

import React, { useRef } from 'react';
import MultiSelectPopup from 'components/common/MultiSelectPopup';
import ReactMarkdown from 'react-markdown';

interface RaceSelectorProps {
  type: string;
  subtype: string;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  onSaveType: (type: string) => void;
  onSaveSubtype: (subtype: string) => void;
  useMarkdown?: boolean;
}

const RaceSelector: React.FC<RaceSelectorProps> = ({
  type,
  subtype,
  isOpen,
  setIsOpen,
  onSaveType,
  onSaveSubtype,
  useMarkdown = false,
}) => {

  const handleTypeChange = (selectedValuesArray: string[]) => {
    onSaveType(selectedValuesArray.join(', '));
  };

  const handleChangeSubtype = (event: React.ChangeEvent<HTMLInputElement>) => {
    onSaveSubtype(event.target.value);
  }

  const valueTextRef = useRef<HTMLSpanElement>(null);

  const handleClickOutside = (event: MouseEvent) => {
    if (valueTextRef.current && !valueTextRef.current.contains(event.target as Node)) {
      setIsOpen(false);
    }
  };

  let content: JSX.Element | string = (type + (subtype ? ` (${subtype})` : '')) || '\u00A0 -- \u00A0'; /* spaces to give a click target */

  if (useMarkdown) {
    content = <ReactMarkdown>{content}</ReactMarkdown>;
  }

  return (
    <span className="multi-select-container edit-field">
      {isOpen && (
        <MultiSelectPopup
          values={type}
          options={races}
          singleSelection={true}
          allowCustom={true}
          onChange={handleTypeChange}
          onClickOutside={handleClickOutside}
          trailer={
            <>
              Subtype: <input value={subtype} style={{ width: '50%' }} onChange={handleChangeSubtype} />
            </>
          }
        />
      )}
      <span onMouseDown={() => setIsOpen(true)} ref={valueTextRef}>
        {content}
      </span>
    </span>
  );
};

const races = [
  "Aberration", "Beast", "Celestial", "Construct", "Dragon", "Elemental",
  "Fey", "Fiend", "Giant", "Humanoid", "Monstrosity", "Ooze", "Plant", "Undead"
];

export default RaceSelector;
